import { z } from "zod";

export const metadataSchema = z
  .object({
    race: z
      .object({
        id: z.number().int().positive(),
        title: z.string().min(1),
        event_description: z.string().nullish(),
        beginning_ranking_term: z.number().nonnegative(),
        end_of_ranking_term: z.number().nonnegative(),
        ranking_user_count: z.number().int().nonnegative().nullish(),
        is_published: z.boolean().optional(),
      })
      .passthrough(),
    aggregateDateEpochMsec: z.number().nonnegative(),
  })
  .passthrough();

export const rawRunnerSchema = z
  .object({
    userId: z.number().int(),
    nickname: z.string(),
    age: z.number().nullish(),
    gender: z.number().int().nullish(),
    prefectureCode: z.number().int().nullish(),
    achievedDate: z.number().nonnegative(),
    totalTime: z.number().int().nonnegative(),
    activityCount: z.number().int().nonnegative(),
    order: z.number().int().positive(),
  })
  .passthrough();

export const snapshotSchema = z
  .object({
    achieverCount: z.number().int().nonnegative(),
    targetDistance: z.number().nonnegative().nullish(),
    achieverList: z.array(rawRunnerSchema),
  })
  .passthrough();

export type SourceMetadata = z.infer<typeof metadataSchema>;
export type RawSnapshot = z.infer<typeof snapshotSchema>;
export type RawRunner = z.infer<typeof rawRunnerSchema>;
